import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8MorningCallingAnnAfter } from "./V8";

export const V8MorningCallingAnn = async (): Promise<any> => {
    mc.think(`Enough with the PC. It's time to call Ann.`);
    doWaitImageByTime(images.v8.V8MCRoomMorningOnPhone_0);
    empty.think(`Dialing...`);
    ann.talk(`Hey! ${mc.name}!`, { method: "Over Phone" });
    ann.talk(`What's up?`, { method: "Over Phone" });
    if (!ann.properties.isCorrupted) {
        mc.talk(`You woke up on the right side of the bed this morning.`, { method: "On Phone" });
        ann.talk(`Hehe, yes. I'm in a good mood.`, { method: "Over Phone" });
        ann.talk(`And...`, { method: "Over Phone" });
        ann.talk(`Oh! Wait! That's so rude of me. You were the one calling.`, { method: "Over Phone" });
    }
    mc.talk(`I was wondering if you are busy today.`, { method: "On Phone" });
    if (!ann.properties.isCorrupted) {

        ann.talk(`Actually I'm free... I decided to take a day off from studying.`, { method: "Over Phone" });
        mc.talk(`Excellent!`, { method: "On Phone" });
    } else {
        ann.talk(`Actually I have something in mind!`, { method: "Over Phone" });
        mc.talk(`What's that?`, { method: "On Phone" });
        ann.talk(`Hehe, first tell me what you wanted to say!`, { method: "Over Phone" });
        mc.talk(`Alright, so...`, { method: "On Phone" });



    }
    mc.talk(`Emily suggested something that could be nice - if you are up for it...`, { method: "On Phone" });
    ann.talk(`I'm listening...`, { method: "Over Phone" });
    mc.talk(`Do you know the small amusement park in town?`, { method: "On Phone" });
    ann.talk(`I do, never been there though...`, { method: "Over Phone" });
    mc.talk(`You want to go there and see what it's like?`, { method: "On Phone" });
    ann.talk(`Of course! That sounds great!`, { method: "Over Phone" });
    mc.talk(`Great!`, { method: "On Phone" });
    mc.talk(`Now it's your turn, what did you want to say?`, { method: "On Phone" });
    ann.talk(`Oh! Since we are meeting I'll tell you in person.`, { method: "Over Phone" });
    ann.talk(`Actually, your timing is perfect! It couldn't have been any better!`, { method: "Over Phone" });
    if (ann.properties.isCorrupted) {
    } else {
        // ann.talk(`I was thinking that maybe we can practice some acting.`, { method: "Over Phone" });
        // mc.talk(`Do you have any script you'd like to run?`, { method: "On Phone" });
        // ann.talk(`Not really... And I'm not sure to be honest...`, { method: "Over Phone" });
        // ann.talk(`I was kinda hoping you'd have something in mind.`, { method: "Over Phone" });
        // mc.talk(`I might have`, { method: "On Phone" });
    }
    mc.talk(`Alright so I'm coming over to pick you up.`, { method: "On Phone" });
    ann.talk(`I'll be waiting!`, { method: "Over Phone" });
    return jump(V8MorningCallingAnnAfter, "V8MorningCallingAnnAfter");
};